module.exports = new __parcel__URL__("fishbite.f148b74e.png").toString();